module.exports = __webpack_public_path__ + "img/pro_capture12.5fdbf97f.png";